import React from 'react';
import Item from '../Item';
import Carousel from 'react-elastic-carousel'
import TestimonialItem from './TestimonialItem';

function Testimonial() {
    let galleryCatagory=[1,2,3,4,5,6,7,8,9]
  return(
      <div className="container mb-5">

    <div class="main-carousel p-3" data-flickity='{ "cellAlign": "left", "contain": true,"wrapAround": true ,"autoPlay": 3000,"accessibility": true}'>
    {galleryCatagory.map((item, i) =>{
        return <div className="carousel-cell mx-2 w-100">
            <TestimonialItem/>
        </div>
    })}
      </div>
    </div>
    )
}

export default Testimonial;
